import { type Maybe } from '@adornis/base/utilTypes.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-loading-state.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import * as QRCodeLibrary from 'qrcode';
import { combineLatest, filter, takeUntil } from 'rxjs';

@customElement('bh-prompt-url-qr')
export class BHPromptUrlQR extends TrDialog<void> {
  static override get element_name() {
    return 'bh-prompt-url-qr';
  }

  @property({ attribute: false }) url = new RXController<Maybe<string>>(this, undefined);
  @state() private readonly _canvasRef = new RXController<Maybe<Element>>(this, undefined);

  override connectedCallback(): void {
    super.connectedCallback();

    combineLatest([this._canvasRef.observable, this.url.observable])
      .pipe(
        filter(([canvas, url]) => !!canvas && !!url),
        takeUntil(this.disconnected),
      )
      .subscribe(([canvas, url]) => {
        if (!canvas || !url) return;
        return QRCodeLibrary.toCanvas(canvas, url);
      });
  }

  override render() {
    return html`
      <x-flex space="md" crossaxis-center>
        <x-flex w100 horizontal space="md" crossaxis-start space-between>
          <tr-button-small
            .color=${this.colors.secondary.shade(300)}
            icon="content_copy"
            .action=${async () => {
              await navigator.clipboard
                .writeText(this.url.value ?? '')
                .then(() => XSnackbar.show(this._translation.translate('copied')));
            }}
          >
            <x-text>${this._translation.translate('copy')}</x-text>
          </tr-button-small>
        </x-flex>

        <canvas
          ${ref(data => {
            if (!this._canvasRef.value) this._canvasRef.next(data);
          })}
          ${css({ width: '300px', aspectRatio: '1 / 1', border: '1px solid #000' })}
        ></canvas>
      </x-flex>
    `;
  }

  override async cancel(returnVal?: any): Promise<void> {
    await this.close();
  }
}
